import AbstractController from './AbstractController';

export default class Product extends AbstractController {
    constructor() {
        super();
        this.bind();
        this.legacy();
    }

    bind() {
        $('.detail-item__buy-link').click(this.onBuyClick.bind(this));
    }

    legacy() {
        $('.detail-item__contents-link').on('click', function (e) {
            e.preventDefault();
            $(this).addClass('detail-item__contents-link--active');
            $(this).siblings('.detail-item__contents-block').addClass('detail-item__contents-block--active');
        });
    }

    onBuyClick(e) {
        dataLayer.push({
            "ecommerce": {
                "currencyCode": "RUB",
                "add": {
                    "products": [
                        {
                            "id": window.appData.product.id,
                            "name": window.appData.product.name,
                            "price": window.appData.product.price,
                            "quantity": 1
                        }
                    ]
                }
            }
        });
    }
}
